import { alpha_spaces, email, max, max_value, min, min_value, regex } from '@vee-validate/rules'

export const Sk = {
  emailAddress: (value: string) => {
    if (!value) return 'Uveďte, prosím Vašu e-mailovú adresu, na ktorú Vám zašleme odpoveď.'
    return email(value) || 'Uveďte, prosím Vašu e-mailovú adresu, na ktorú Vám zašleme odpoveď.'
  },
  fullName: (value: string) => {
    if (!value) return 'Vyplňte prosím meno a priezvisko.'
    if (!regex(value.trim(), { regex: /^([a-zA-Zá-ž-]+\s)*[a-zA-Zá-ž-]+$/ })) return 'Meno a priezvisko obsahuje nepovolené znaky.'
    return /[a-ž]+\s[a-ž]+/i.test(value) || 'Veľmi krátke: Napíšte prosím celé meno a priezvisko.'
  },
  city: (value: string) => {
    if (!value) return 'Vyplňte prosím meno spoločnosti.'
    return max(value, { length: 59 }) || 'Napíšte prosím platný názov mesta.'
  },
  age: (value: string) => {
    if (!value) return 'Vyplňte prosím vek.'
    return min_value(value, { min: 18 }) ? (max_value(value, { max: 70 }) || 'Poistník musí byť mladší ako 70 rokov.') : 'Poistník musí byť starší ako 18 rokov.'
  },
  phone: async (value: string) => {
    if (!value) return 'Vyplňte prosím telefón.'
    if (!max(value, { length: 13 })) return 'Telefonné číslo nie je platné.'
    return min(value, { length: 9 }) || 'Telefonné číslo nie je platné.'
  },
  zip: (value: string) => {
    if (!value) return 'Vyplňte prosím PSČ.'
    return min(value, { length: 4 }) ? (max(value, { length: 5 }) || 'PSČ musí mať maximálne 5 znakov.') : 'PSČ musí mať minimálne 4 znaky.'
  },
  yearOfBirth: (value: number) => {
    if (!value) return 'Vyplňte prosím rok.'
    const date = new Date()
    return min_value(value, { min: date.getFullYear() - 100 }) ? (max_value(value, { max: date.getFullYear() }) || 'Zadaný rok je neplatný. Ak ste cestovateľ v čase, dajte nám vedieť!') : 'Osoba nesmí být starší 100 let.'
  },
  day: (value: number) => {
    if (!value) return 'Vyplňte prosím deň.'
    return min_value(value, { min: 1 }) ? (max_value(value, { max: 31 }) || 'Zadaný dátum nesmie byť vyšší ako 31') : 'Zadaná hodnota dátumu musí byť aspoň 1'
  },
  month: (value: number) => {
    if (!value) return 'Vyplňte prosím mesiac.'
    return min_value(value, { min: 1 }) ? (max_value(value, { max: 12 }) || 'Zadaný dátum nesmie byť vyšší ako 12') : 'Zadaná hodnota dátumu musí byť aspoň 1'
  },
}

export const Cz = {
  emailAddress: (value: string) => {
    if (!value) return 'Uveďte prosím Vaši e-mailovou adresu, na kterou Vám zašleme odpověď.'
    return email(value) || 'Uveďte prosím Vaši e-mailovou adresu, na kterou Vám zašleme odpověď.'
  },
  fullName: (value: string) => {
    if (!value) return 'Vyplňte prosím jméno a příjmení.'
    if ((!alpha_spaces(value, { locale: undefined }))) return 'Jméno a příjmení obsahuje nepovolené znaky.'
    return /[a-ž]+\s[a-ž]+/i.test(value) || 'Velmi krátké: Napište prosím celé jméno a příjmení.'
  },
  city: (value: string) => {
    if (!value) return 'Vyplňte prosím jméno společnosti.'
    return max(value, { length: 59 }) || 'Napište prosím platný název města.'
  },
  age: (value: string) => {
    if (!value) return 'Vyplňte prosím věk.'
    return min_value(value, { min: 18 }) ? (max_value(value, { max: 70 }) || 'Pojistník musí být mladší 70 let.') : 'Pojistník musí být starší 18 let.'
  },
  phone: async (value: string) => {
    if (!value) return 'Vyplňte prosím telefon.'
    if (!max(value, { length: 11 })) return 'Telefonní číslo není platné.'
    return min(value, { length: 9 }) || 'Telefonní číslo není platné.'
  },
  zip: (value: string) => {
    if (!value) return 'Vyplňte prosím PSČ.'
    return min(value, { length: 4 }) ? (max(value, { length: 5 }) || 'PSČ musí mít maximálně 5 znaků.') : 'PSČ musí mít minimálně 4 znaky.'
  },
  yearOfBirth: (value: number) => {
    if (!value) return 'Vyplňte prosím rok.'
    const date = new Date()
    return min_value(value, { min: date.getFullYear() - 100 }) ? (max_value(value, { max: date.getFullYear() }) || 'Zadaný rok je neplatný. Pokud jste cestovatel časem, dejte nám vědět!') : 'Osoba nesmí být starší 100 let.'
  },
  day: (value: number) => {
    if (!value) return 'Vyplňte prosím den.'
    return min_value(value, { min: 1 }) ? (max_value(value, { max: 31 }) || 'Zadaná hodnota data musí být maximálně 31') : 'Zadaná hodnota data musí být minimálně 1'
  },
  month: (value: number) => {
    if (!value) return 'Vyplňte prosím měsíc.'
    return min_value(value, { min: 1 }) ? (max_value(value, { max: 12 }) || 'Zadaná hodnota data musí být maximálně 12') : 'Zadaná hodnota data musí být minimálně 1'
  },
}

export function getRules() {
  const appConfig = useAppConfig()
  const locale = appConfig.locale.code

  return locale === 'cs' ? Cz : Sk
}
